"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StoreManagement',
  data: function data() {
    return {
      loading: false,
      showCategoryDropdown: false,
      filterForm: {
        storeName: '',
        merchantId: '',
        storeStatus: '',
        businessStatus: '',
        location: '',
        storeCategory: 'supermarket'
      },
      merchantOptions: [{
        label: '商户1',
        value: 'merchant1'
      }, {
        label: '商户2',
        value: 'merchant2'
      }],
      locationOptions: [{
        label: '四川省-成都市-武侯区',
        value: 'sichuan-chengdu-wuhou'
      }, {
        label: '四川省-成都市-锦江区',
        value: 'sichuan-chengdu-jinjiang'
      }, {
        label: '北京市-朝阳区',
        value: 'beijing-chaoyang'
      }],
      tableData: [],
      pagination: {
        page: 1,
        size: 20,
        total: 400
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList: function getList() {
      var _this = this;
      this.loading = true;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/rsApi'));
      }).then(function (_ref) {
        var getMockStoreList = _ref.getMockStoreList;
        getMockStoreList(_objectSpread({
          page: _this.pagination.page,
          size: _this.pagination.size
        }, _this.filterForm)).then(function (response) {
          _this.tableData = response.data.list;
          _this.pagination.total = response.data.total;
          _this.loading = false;
        });
      });
    },
    // 店铺状态
    getStoreStatusType: function getStoreStatusType(status) {
      var statusMap = {
        'open': 'success',
        'preparing': 'warning',
        'closed': 'danger'
      };
      return statusMap[status] || 'info';
    },
    getStoreStatusText: function getStoreStatusText(status) {
      var statusMap = {
        'open': '已开业',
        'preparing': '筹备中',
        'closed': '已停用'
      };
      return statusMap[status] || '未知';
    },
    // 营业状态
    getBusinessStatusType: function getBusinessStatusType(status) {
      var statusMap = {
        'operating': 'success',
        'suspended': 'warning',
        'closed': 'info'
      };
      return statusMap[status] || 'info';
    },
    getBusinessStatusText: function getBusinessStatusText(status) {
      var statusMap = {
        'operating': '营业中',
        'suspended': '暂停营业',
        'closed': '休息中'
      };
      return statusMap[status] || '未知';
    },
    // 类别改变
    handleCategoryChange: function handleCategoryChange(value) {
      this.showCategoryDropdown = false;
      this.getList();
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.getList();
    },
    // 重置筛选
    resetFilter: function resetFilter() {
      this.filterForm = {
        storeName: '',
        merchantId: '',
        storeStatus: '',
        businessStatus: '',
        location: '',
        storeCategory: 'supermarket'
      };
      this.handleSearch();
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.$message.info('编辑功能开发中...');
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm('确定要删除这家店铺吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.getList();
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.getList();
    },
    // 获取营业中店铺数量
    getOperatingCount: function getOperatingCount() {
      return this.tableData.filter(function (item) {
        return item.businessStatus === 'operating';
      }).length;
    },
    // 新增店铺
    handleAdd: function handleAdd() {
      this.$message.info('新增店铺功能开发中...');
    },
    // 查看详情
    handleView: function handleView(row) {
      this.$message.info('查看店铺详情功能开发中...');
    },
    // 获取店铺状态图标
    getStoreStatusIcon: function getStoreStatusIcon(status) {
      var iconMap = {
        'open': 'el-icon-success',
        'preparing': 'el-icon-warning',
        'closed': 'el-icon-error'
      };
      return iconMap[status] || 'el-icon-info';
    },
    // 获取营业状态图标
    getBusinessStatusIcon: function getBusinessStatusIcon(status) {
      var iconMap = {
        'operating': 'el-icon-success',
        'suspended': 'el-icon-warning',
        'closed': 'el-icon-info'
      };
      return iconMap[status] || 'el-icon-info';
    }
  }
};